import { render, staticRenderFns } from "./DocumentRequest.vue?vue&type=template&id=7b13c634&scoped=true&"
import script from "./DocumentRequest.vue?vue&type=script&lang=js&"
export * from "./DocumentRequest.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequest.vue?vue&type=style&index=0&id=7b13c634&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b13c634",
  null
  
)

export default component.exports